export default __webpack_public_path__ + "static/media/pwabudgettracker.9d25910c.png";